module.exports = __webpack_public_path__ + "img/full-logo.b8f795bf.jpg";